const childrenLoaded = require("@alexspirgel/children-loaded");

class EventsNewsList extends ESWPPostList {

	constructor() {
		super();
		this.paginationAttachEventListeners();
		this.addUpdateTemplateElementCallback('pagination', this.paginationAttachEventListeners);
	}

	static getQueryStrings() {
		const searchParams = new URLSearchParams(window.location.search);
		const queryStrings = {};
		for (const [key, value] of searchParams.entries()) {
			queryStrings[key] = value;
		}
		return queryStrings;
	}

	static setQueryStrings(queryStrings) {
		const searchParams = new URLSearchParams(window.location.search);
		for (const key in queryStrings) {
			const value = queryStrings[key];
			if (value === false
				|| (key === 'page' && (value === 1 || value === '1'))) {
				searchParams.delete(key);
			}
			else {
				searchParams.set(key, value);
			}
		}
		const newURL = new URL(window.location.href);
		newURL.search = searchParams.toString();
		window.history.replaceState({path: newURL.href}, '', newURL.href);
	}

	static getFormValues(form) {
		const formData = {};
		const formElements = form.elements;
		for (let i = 0; i < formElements.length; i++) {
			const currentElement = formElements[i];
			if (currentElement.name && currentElement.value) {
				formData[currentElement.name] = currentElement.value;
			}
		}
		return formData;
	}

	static setFormValues(form, values) {
		for (const name in values) {
			const formElements = form.elements;
			for (let i = 0; i < formElements.length; i++) {
				const currentElement = formElements[i];
				if (currentElement.name === name) {
					currentElement.value = values[name];
				}
			}
		}
	}

	static isAdmin() {
		return document.body.classList.contains('wp-admin');
	}

	async connectedCallback() {
		await childrenLoaded(this);
		if (this.queryStringFiltering) {
			this.queryStrings = this.constructor.getQueryStrings();
			const queryStringsTermIds = this.queryStringSlugsToTermIds(this.queryStrings);
			this.setFormValues(queryStringsTermIds);
		}
		this.formAttachEventListeners();
		this.addUpdateTemplateElementCallback("form", this.formAttachEventListeners);
		this.formOnChangeListener();
		this.categoryChangeListener();
	}

	get queryStringFiltering() {
		const queryStringFilteringAttribute = this.getAttribute('data-query-string-filtering');
		if (!this.constructor.isAdmin() && queryStringFilteringAttribute == 'true') {
			return true;
		}
		else {
			return false;
		}
	}

	queryStringSlugsToTermIds(formData) {
		formData = Object.assign({}, formData);
		if (typeof formData['category_filter'] === 'string' && formData['category_filter'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#category_filter option[data-slug="${formData['category_filter']}"]`);
			if (optionElement) {
				formData['category_filter'] = optionElement.getAttribute('value');
			}
		}
		
		// Handle year filter
		if (typeof formData['year_filter'] === 'string' && formData['year_filter'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#year_filter option[data-slug="${formData['year_filter']}"]`);
			if (optionElement) {
				formData['year_filter'] = optionElement.getAttribute('value');
			}
		}
		
		return formData;
	}

	formDataTermIdsToSlugs(formData) {
		formData = Object.assign({}, formData);
		if (typeof formData['category_filter'] === 'string' && formData['category_filter'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#category_filter option[value="${formData['category_filter']}"]`);
			if (optionElement) {
				formData['category_filter'] = optionElement.getAttribute('data-slug');
			}
		}
		
		// Handle year filter
		if (typeof formData['year_filter'] === 'string' && formData['year_filter'].length > 0) {
			const optionElement = this.templateElements.form.querySelector(`#year_filter option[value="${formData['year_filter']}"]`);
			if (optionElement) {
				formData['year_filter'] = optionElement.getAttribute('data-slug');
			}
		}
		
		return formData;
	}

	getFormValues() {
		return this.constructor.getFormValues(this.templateElements.form);
	}

	setFormValues(values) {
		return this.constructor.setFormValues(this.templateElements.form, values);
	}

	formAttachEventListeners = () => {
		this.templateElements.form.addEventListener('submit', this.formSubmitHandler);
	};

	formSubmitHandler = (event) => {
		if (event.preventDefault) {
			event.preventDefault();
		}
		this.submitForm();
		return false;
	};

	formOnChangeListener = () => {
		const selects = this.templateElements.form.querySelectorAll('select');

		if (!selects.length) {
			return;
		}

		for (let select of selects) {
			select.addEventListener('customFilterChange', (e) => {
				e.stopPropagation();
				this.formSubmitHandler(e);
			});
			
			// Only add this for non-category filter to avoid double submission
			if (select.id !== 'category_filter') {
				select.addEventListener('change', (e) => {
					this.formSubmitHandler(e);
				});
			}
		}
	};
	

	
// Listen for category changes and update years
categoryChangeListener = () => {
    const categorySelect = this.templateElements.form.querySelector('#category_filter');
    if (!categorySelect) {
        console.log('Category select element not found');
        return;
    }
    console.log('Setting up category change listener');
    
    // Direct AJAX call to get years for a category
    const updateYearsForCategory = (categoryId) => {
        console.log('updateYearsForCategory called with categoryId:', categoryId);
        
        const ajaxUrl = window.eventsNewsListData?.ajaxurl || '/wp-admin/admin-ajax.php';
        console.log('AJAX URL:', ajaxUrl);
        
        const yearSelect = this.templateElements.form.querySelector('#year_filter');
        
        if (!yearSelect) {
            console.log('Year select element not found');
            return;
        }
        
        // Save current selection
        const currentValue = yearSelect.value;
        console.log('Current year value:', currentValue);
        
        // Show loading state if possible
        if (window.jQuery && jQuery(yearSelect).data('selectBox-selectBoxIt')) {
            console.log('Disabling SelectBoxIt');
            jQuery(yearSelect).data('selectBox-selectBoxIt').disable();
        }
        
        // Make the AJAX call
        console.log('Making AJAX request for years data');
        jQuery.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_years_for_category',
                category_id: categoryId,
                security: window.eventsNewsListData?.nonce || ''
            },
            dataType: 'json',
            success: (response) => {
                console.log('AJAX success. Raw response:', response);
                
                // Extract years data handling different possible response formats
                let yearsData = [];
                
                if (response.success) {
                    if (response.data && Array.isArray(response.data.years)) {
                        console.log('Found years in response.data.years');
                        yearsData = response.data.years;
                    } else if (Array.isArray(response.years)) {
                        console.log('Found years in response.years');
                        yearsData = response.years;
                    } else {
                        console.log('Response format unexpected:', response);
                    }
                } else {
                    console.log('Response success flag is false or missing');
                }
                
                console.log('Extracted years data:', yearsData);
                
                // If we have years data, update the dropdown
                if (yearsData.length > 0) {
                    console.log('Updating year dropdown with', yearsData.length, 'options');
                    
                    // Clear existing options except first one (All Years)
                    while (yearSelect.options.length > 1) {
                        yearSelect.remove(1);
                    }
                    
                    // Add new options
                    yearsData.forEach(year => {
                        const option = document.createElement('option');
                        option.value = year;
                        option.setAttribute('data-slug', year);
                        option.textContent = year;
                        yearSelect.appendChild(option);
                    });
                    
                    console.log('Added year options. Restoring value if possible');
                    
                    // Try to restore previous value if it exists
                    const valueExists = Array.from(yearSelect.options).some(opt => opt.value === currentValue);
                    yearSelect.value = valueExists ? currentValue : 'all';
                    console.log('Year select value set to:', yearSelect.value);
                    
                    // Update SelectBoxIt if it exists
                    if (window.jQuery && jQuery(yearSelect).data('selectBox-selectBoxIt')) {
                        console.log('Refreshing SelectBoxIt');
                        jQuery(yearSelect).data('selectBox-selectBoxIt').enable().refresh();
                    }
                    
                    // Submit the form
                    console.log('Submitting form');
                    this.formSubmitHandler({ preventDefault: () => {} });
                } else {
                    console.log('No valid years data found, not updating dropdown');
                    // Re-enable the select if no data was found
                    if (window.jQuery && jQuery(yearSelect).data('selectBox-selectBoxIt')) {
                        jQuery(yearSelect).data('selectBox-selectBoxIt').enable();
                    }
                }
            },
            error: (xhr, status, error) => {
                console.log('AJAX error:', status, error);
                if (xhr.responseText) {
                    console.log('Response text:', xhr.responseText.substring(0, 200));
                }
                
                // Re-enable the select
                if (window.jQuery && jQuery(yearSelect).data('selectBox-selectBoxIt')) {
                    jQuery(yearSelect).data('selectBox-selectBoxIt').enable();
                }
            }
        });
    };
    
    // Multiple redundant event binding strategies to ensure changes are captured
    
    // Strategy 1: Standard DOM event listener
    categorySelect.addEventListener('change', (e) => {
        console.log('DOM event listener triggered for category change');
        const categoryId = e.target.value;
        updateYearsForCategory(categoryId);
    });
    
    // Strategy 2: jQuery change event
    if (window.jQuery) {
        jQuery(categorySelect).on('change', function() {
            console.log('jQuery event listener triggered for category change');
            const categoryId = this.value;
            updateYearsForCategory(categoryId);
        });
    }
    
    // Strategy 3: Direct SelectBoxIt binding
    if (window.jQuery && jQuery.fn.selectBoxIt) {
        try {
            const selectBoxIt = jQuery(categorySelect).data('selectBox-selectBoxIt');
            if (selectBoxIt) {
                console.log('Setting up SelectBoxIt event handlers');
                
                jQuery(selectBoxIt).on('open', function() {
                    console.log('SelectBoxIt dropdown opened');
                    // Store original value to detect changes when closed
                    jQuery(this).data('original-value', categorySelect.value);
                });
                
                jQuery(selectBoxIt).on('close', function() {
                    console.log('SelectBoxIt dropdown closed');
                    const originalValue = jQuery(this).data('original-value');
                    const newValue = categorySelect.value;
                    console.log('Values - original:', originalValue, 'new:', newValue);
                    
                    if (originalValue !== newValue) {
                        console.log('Value changed, updating years');
                        updateYearsForCategory(newValue);
                    }
                });
            } else {
                console.log('SelectBoxIt instance not found on category select');
            }
        } catch (e) {
            console.log('SelectBoxIt binding error:', e);
        }
    }
    
    // Strategy 4: Fallback polling for changes
    if (window.jQuery) {
        // Store initial value
        jQuery(categorySelect).data('last-value', categorySelect.value);
        console.log('Setting up polling strategy. Initial value:', categorySelect.value);
        
        // Check periodically for changes
        const pollInterval = setInterval(() => {
            const lastValue = jQuery(categorySelect).data('last-value');
            const currentValue = categorySelect.value;
            
            if (lastValue !== currentValue) {
                console.log('Polling detected value change from', lastValue, 'to', currentValue);
                jQuery(categorySelect).data('last-value', currentValue);
                updateYearsForCategory(currentValue);
            }
        }, 500); // Check every 500ms
        
        // Store interval ID for cleanup
        this.categoryPollInterval = pollInterval;
    }
    
    // Handle initial category value
    console.log('Handling initial category value:', categorySelect.value);
    updateYearsForCategory(categorySelect.value);
};

// Add cleanup method to avoid memory leaks
disconnectedCallback() {
    console.log('Component disconnected, cleaning up resources');
    
    // Clear polling interval if it exists
    if (this.categoryPollInterval) {
        clearInterval(this.categoryPollInterval);
        console.log('Cleared category poll interval');
    }
    
    // Call parent disconnectedCallback if it exists
    if (super.disconnectedCallback) {
        super.disconnectedCallback();
    }
}




	
	// Maintained for backward compatibility
	updateYearOptions = (years) => {
		return Promise.resolve();
	};

	async submitForm(page = 1) {
		const formData = this.getFormValues();
		formData['archive_id'] = this.getAttribute('data-archive-id');
		const args = {
			key: this.key,
			templates: ['results', 'pagination'],
			request_data: formData,
			page: page,
		};
		const formDataSlugs = this.formDataTermIdsToSlugs(formData);
		
		if (this.queryStringFiltering) {
			for (const name in formDataSlugs) {
				if (formDataSlugs[name] === '') {
					formDataSlugs[name] = false;
				}
			}
			formDataSlugs['page'] = page;
			this.constructor.setQueryStrings(formDataSlugs);
		}
		
		const newTemplates = await this.fetchTemplates(args);
		this.updateTemplateElement('results', newTemplates.results);
		this.updateTemplateElement('pagination', newTemplates.pagination);
	}
	
	paginationAttachEventListeners = () => {
		const pagerButtonElements = this.templateElements.pagination.querySelectorAll('button');
		for (let buttonElement of pagerButtonElements) {
			buttonElement.addEventListener('click', this.paginationButtonClickHandler);
		}
	}

	paginationButtonClickHandler = async (event) => {
		const page = event.target.getAttribute('data-page');
		await this.appendPage(page);
	}

	async getPage(page) {
		const formData = this.getFormValues();
		formData['page'] = page;
		
		const args = {
			key: this.key,
			templates: ['results', 'pagination'],
			request_data: formData,
			page: page
		};
		const newTemplates = await this.fetchTemplates(args);
		return newTemplates;
	}

	async goToPage(page) {
		const newTemplates = await this.getPage(page);
		this.updateTemplateElement('results', newTemplates.results);
		this.updateTemplateElement('pagination', newTemplates.pagination);
	}

	async appendPage(page) {
		const newTemplates = await this.getPage(page);
		const resultsContainer = this.querySelector(
			'[data-post-list-template="results"]'
		);
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = newTemplates.results;
		const newResultsItems = htmlObject.querySelectorAll(
			'[data-post-list-template="results"] > li'
		);
		for (const newResultsItem of newResultsItems) {
			resultsContainer.append(newResultsItem);
		}
		this.updateTemplateElement("pagination", newTemplates.pagination);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('post-list-events-news-list', EventsNewsList, {extends: 'div'});
});